import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './ServiceFAQ.css';

export interface FAQItem {
  q: string;
  a: string;
}

interface ServiceFAQProps {
  items: FAQItem[];
  heading?: string;
}

export const ServiceFAQ: React.FC<ServiceFAQProps> = ({ items, heading = 'Frequently Asked Questions' }) => {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const toggle = (i: number) => setOpenIdx(prev => (prev === i ? null : i));

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map(({ q, a }) => ({
      '@type': 'Question',
      name: q,
      acceptedAnswer: { '@type': 'Answer', text: a },
    })),
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      <section className="rn-sfaq">
      <div className="rn-sfaq__inner">
        <h2 className="rn-sfaq__heading">{heading}</h2>
        <ul className="rn-sfaq__list">
          {items.map(({ q, a }, i) => (
            <li key={i} className={`rn-sfaq__item${openIdx === i ? ' is-open' : ''}`}>
              <button
                className="rn-sfaq__question"
                onClick={() => toggle(i)}
                aria-expanded={openIdx === i}
              >
                <span>{q}</span>
                <svg className="rn-sfaq__chevron" width="18" height="18" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                  aria-hidden="true">
                  <path d="M6 9l6 6 6-6" />
                </svg>
              </button>
              <div className="rn-sfaq__answer" aria-hidden={openIdx !== i}>
                <p>{a}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
    </>
  );
};
